import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  cover: string;
  status: string;
  author: string;
  category: string;
  rating: number;
  views: number;
}

export default function ComicCard({ id, title, cover, status, author, rating, views }: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[5/7] w-full relative overflow-hidden">
          <img
            src={cover}
            alt={title}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            width="400"
            height="560"
          />
          <div className="absolute top-2 left-2">
            <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
              status === '完结' ? 'bg-secondary-500 text-background-50' : 'bg-accent-500 text-background-50'
            }`}>
              {status}
            </span>
          </div>
          <div className="absolute top-2 right-2 bg-background-900/70 text-foreground-50 text-xs px-2 py-0.5 rounded flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs" />
            <span>{rating}</span>
          </div>
        </div>
        <div className="p-3">
          <h3 className="text-sm font-medium text-foreground-900 truncate mb-1 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <span>{author}</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" />
              {formatViews(views)}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}